import React from "react";
import HeaderLogo from "../../components/headerLogo/index";
import { Container, Section, Aside, Button } from "./styles";
import TitlePage from "../../components/titlePage/index";
import img from "../../assets/images/eu1.png";
import AnimatedBackground from "../../components/background/index";

function Sobre() {
  return (
    <>
      <AnimatedBackground />
      <Container>
        <HeaderLogo />
        <TitlePage subtitle="Sobre Mim" title="Conheça-me mais" />
        <Section>
          <div>
            <h1>
              Eu me chamo <strong>Eliedson Gomes</strong>
            </h1>
            <p>
            Desenvolvedor Backend com experiência no desenvolvimento de APIs REST, aplicações web e microsserviços utilizando Python, FastAPI, Flask e PostgreSQL.
            Atuo na construção de sistemas escaláveis, integrações entre serviços, autenticação JWT, manipulação de banco de dados SQL/NoSQL e containerização com Docker, sempre aplicando boas práticas como Clean Code, SOLID e arquitetura limpa.
            Possuo experiência prática com desenvolvimento backend utilizando Python e Node.js, além de conhecimento em cloud computing com AWS, versionamento com Git/GitHub e integração contínua (CI/CD).
            Também tenho vivência com React e TypeScript no frontend, o que contribui para uma visão full-stack e melhor integração entre aplicações.
            </p>

            <p>
            Meu objetivo é transformar ideias em soluções digitais que agreguem valor aos usuários e empresas, focando em excelência técnica, design funcional e performance. Busco colaborar em projetos que envolvam desafios no front-end e back-end, contribuindo com minhas habilidades e aprendendo continuamente para entregar produtos de alta qualidade.
            </p>
            
          </div>
          <Aside>
            <ul>
              <li>
                Nome:
                <span>Eliedson Gomes dos Santos</span>
              </li>
              <li>
                Idade:
                <span>47 anos, Casado</span>
              </li>
              <li>
                Cidade:
                <span>Recife, Pernambuco</span>
              </li>
              <li>
                Email:
                <span>
                  <a href="mailto:eliedson.dev@gmail.com">
                  eliedson.dev@gmail.com
                  </a>
                </span>
              </li>
            </ul>

            <Button
              href="https://drive.google.com/uc?export=download&id=1Rh0xkQkcYdUYj1FdCNINiKhLKgsYhhJq"
              target="blank"
              rel="noopener noreferrer"
            >
              <strong>📋 Currículo</strong>
            </Button>
          </Aside>
        </Section>
        <img src={img} alt="Imagem de fundo" />
      </Container>
    </>
  );
}

export default Sobre;
